import { NgModule } from '@angular/core';
import { NumberCommaPipe } from './number-comma/number-comma.pipe';
// PRIVATE
import { OptionsListLabelPipe } from './_options-list/_options-list-label.pipe';
import { OptionsListStylePipe } from './_options-list/_options-list-style.pipe';


import { FilterPipe } from './filter/filter.pipe';
import { OrderByPipe } from './order-by/order-by.pipe';
import { ParsePipe } from './parse/parse.pipe';
import { CheckPipe } from './check/check.pipe';


@NgModule({
    declarations: [
        OptionsListLabelPipe,
        OptionsListStylePipe,
        CheckPipe,
        FilterPipe,
        NumberCommaPipe,
        OrderByPipe,
        ParsePipe
    ],
    exports: [
        OptionsListLabelPipe,
        OptionsListStylePipe,
        CheckPipe,
        FilterPipe,
        NumberCommaPipe,
        OrderByPipe,
        ParsePipe
    ]
})
export class PipesModule {
}
